export default __webpack_public_path__ + "static/media-f134c947bdd48bde9cabcd3d85db6763.png";